import { render } from "./Tab.vue?vue&type=template&id=2b079fee&scoped=true&ts=true"
import script from "./Tab.vue?vue&type=script&lang=ts"
export * from "./Tab.vue?vue&type=script&lang=ts"

import "./Tab.vue?vue&type=style&index=0&id=2b079fee&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b079fee"]])

export default __exports__